export const PA_WIZARD_DEFAULTS = Object.freeze({
  contract_type: 'residential_home',
  closing_days: '30',
  contingency_start_days: '3',
  inspection_days: '10',
  negotiation_days: '7',
  title_extension_days: '30',
});

export function applyPaWizardDefaults(seeded = {}) {
  const next = { ...seeded };
  Object.entries(PA_WIZARD_DEFAULTS).forEach(([key, value]) => {
    if (next[key] == null || next[key] === '') next[key] = value;
  });
  return next;
}

export const PA_QUESTION_SKIP_IF = Object.freeze({
  survey_mortgage_payer: (values) => (
    values?.mortgage_survey_report !== 'mortgage report'
    && values?.mortgage_survey_report !== 'survey report'
  ),
  home_warranty_buyer_request: (values) => values?.home_warranty_seller === 'yes',
  commission_percent: (values) => values?.commission_structure === 'fixed',
  commission_amount: (values) => values?.commission_structure !== 'fixed',
});
